import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { notifyParent } from 'mailup-react-helpers'
import { LINK_VARIANT_HIGHLIGHT, Link } from 'mailup-web-components'

const Info: FC = () => {
  const intl = useIntl()

  const handleClick = (): void => {
    const route = '/filters/list'
    notifyParent('redirectMainFrame', [
      `filters_app_redirector.aspx?r=${encodeURIComponent(route)}`,
    ])
  }

  return (
    <div>
      {intl.formatMessage(
        {
          id: 'Load.UnsubscriptionCampaignsList.UnsubscriptionCampaignsInfo',
        },
        {
          linebreak: <br />,
          strong: (chunks) => <strong>{chunks}</strong>,
          link: (chunks) => (
            <Link
              variant={LINK_VARIANT_HIGHLIGHT}
              data-mu-test="engagement-filters"
              onClick={handleClick}
            >
              {chunks}
            </Link>
          ),
        },
      )}
    </div>
  )
}

export default Info
